'use strict';
import Api from '../abstract';

export let GET_KINTONE = (successCallback, errorCallback) => {
    let url = `/user/setting/kintone`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let SETTING_KINTONE = (params, successCallback, errorCallback) => {
    let url = `/user/setting/kintone`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let SETTING_PASSWORD_KINTONE = (params, successCallback, errorCallback) => {
    let url = `/user/setting/kintone/${params.payload.data.id}`;
    let data = params.payload.data;
    return Api.patch(url, data).then(successCallback).catch(errorCallback);
};

export let CANCEL_KINTONE = (params, successCallback, errorCallback) => {
    let url = `/user/setting/kintone`;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};

export let ADD_WORKSPACE = (params, successCallback, errorCallback) => {
    let url = `/user/link/workspaces`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let GET_WORKSPACE_KINTONE = (params, successCallback, errorCallback) => {
    let url = `/user/link/workspaces?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let DELETE_WORKSPACE = (params, successCallback, errorCallback) => {
    let data = params.payload.data.uid;
    data = data.toString();
    let url = `/user/link/workspaces/` + data;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};

export let WORKSPACE_STATUS = (params, successCallback, errorCallback) => {
    let data = params.payload.data.uid;
    data = data.toString();
    let url = `/user/link/workspaces/` + data;
    return Api.patch(url).then(successCallback).catch(errorCallback);
};

export let SETTING_EMAIL = (params, successCallback, errorCallback) => {
    let url = `/user/setting/google`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let GET_SETTING_EMAIL = (params, successCallback, errorCallback) => {
    let url = `/user/setting/google`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let CANCEL_SETTING_EMAIL = (params, successCallback, errorCallback) => {
    let url = `/user/setting/google`;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};
